<template>
  <div class="my-courses">
    <div class="card">
      <div class="card-header">
        <span class="card-title">我的课程</span>
      </div>
      <div class="card-body">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#fff6e8', color: '#515a6e' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50rem"
            align="center"
          >
          </el-table-column>
          <el-table-column
            :prop="value"
            :label="item"
            v-for="(item, value) in tableTitle"
            :key="item"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="操作"
            width="170rem"
            align="center"
          >
            <template slot-scope="scope">
              <el-button class="button" @click="checkDetails(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="80%"
      top="2%"
    >
      <div class="card-body">
        <el-table
          :data="paginatedCourses"
          border
          :header-cell-style="{ background: '#fff6e8', color: '#515a6e' }"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="signUpTime"
            label="报名时间"
            align="center"
            width="160rem"
          ></el-table-column>
          <el-table-column
            prop="trainingType"
            label="培训方式"
            align="center"
            width="80rem"
          ></el-table-column>
          <el-table-column
            prop="trainingTitle"
            label="培训标题"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="trainingName"
            label="课程名称"
            align="center"
            width="200rem"
          ></el-table-column>
          <el-table-column
            prop="trainingAdd"
            label="上课地点"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="beginTime"
            label="开课时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            label="结课时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="duration"
            label="时长"
            align="center"
            width="70rem"
          ></el-table-column>
          <el-table-column
            prop="classHours"
            label="课程学时"
            align="center"
            width="70rem"
          ></el-table-column>
          <el-table-column
            prop="unitPrice"
            label="培训费用"
            align="center"
            width="70rem"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.unitPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="查看" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="!scope.row.isExpire && !scope.row.trainingStudyProgress"
                class="action-button"
                type="warning"
                size="mini"
                @click="onlineStudy(scope.row)"
              >
                在线学习
              </el-button>
              <el-button
                v-if="scope.row.isExpire"
                class="disabled-button"
                type="info"
                size="mini"
                disabled
              >
                课程学习时间已到期
              </el-button>
              <el-button
                v-if="scope.row.trainingStudyProgress && !scope.row.isExpire"
                class="disabled-button"
                type="info"
                size="mini"
                disabled
              >
                已完成学习
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pages">
          <el-pagination
            @size-change="handleDialogSizeChange"
            @current-change="handleDialogCurrentChange"
            :current-page="dialogCurrentPage"
            :page-size="dialogPageSize"
            layout="prev, pager, next, jumper"
            :total="dialogTotal"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { myCourse } from "@/api/course.js";
import { findRoute } from "@/utils/routerHelper.js";
export default {
  data() {
    return {
      currentPage: 1,
      total: 5,
      tableTitle: {
        trainingBatch: "培训批次",
        category: "课程分类",
        trainingTitle: "培训标题",
        trainingType: "培训方式",
        albumName: "合辑名称",
        // trainingPlaces: "培训名额",
        // signUpCount: "报名人数",
        // availableSlots: "剩余人数",
        beginTime: "开课时间",
        endTime: "结课时间",
        // classHours: "学时",
      },
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    // 从 Vuex 中获取弹窗状态
    ...mapState("dialog", {
      dialogVisible: (state) => state.visible,
      courses: (state) => state.courses,
      dialogCurrentPage: (state) => state.currentPage,
      dialogPageSize: (state) => state.pageSize,
      dialogTotal: (state) => state.total,
    }),
    // 计算分页后的数据
    paginatedCourses() {
      const start = (this.dialogCurrentPage - 1) * this.dialogPageSize;
      const end = start + this.dialogPageSize;
      return this.courses.slice(start, end);
    },
  },
  methods: {
    ...mapMutations("routerData", ["changeRouterList"]),
    ...mapMutations("dialog", [
      "SET_DIALOG_CURRENT_PAGE",
      "SET_DIALOG_PAGE_SIZE",
    ]),
    ...mapActions("dialog", ["showDialog", "closeDialog"]),
    getList() {
      myCourse({
        current: this.currentPage,
        size: 10,
      }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records.map((v) => {
            return {
              ...v,
              ...v.trainingAlbum,
              beginTime: v.trainingAlbum.beginTime
                ? v.trainingAlbum.beginTime.slice(0, -3)
                : "",
              endTime: v.trainingAlbum.endTime
                ? v.trainingAlbum.endTime.slice(0, -3)
                : "",
              category:
                v.trainingAlbum.category && v.trainingAlbum.category.length > 0
                  ? v.trainingAlbum.category.join(",")
                  : "",
            };
          });
          console.log(this.tableData);
        }
        // console.log(res)
      });
    },
    isExpired(endTime) {
      const end = new Date(endTime);
      const now = new Date();
      return end < now;
    },
    onlineStudy(course) {
      if (course.beginTime) {
        const beginTime = new Date(course.beginTime).getTime();
        const now = Date.now();
        if (now < beginTime) {
          this.$message.warning("学习未开始");
          return;
        }
      }
      if (course.endTime) {
        const endTime = new Date(course.endTime).getTime();
        const now = Date.now();
        if (now > endTime) {
          this.$message.warning("课程已结束");
          return;
        }
      }
      this.$router.push({
        path: "/personalCenter/trainingSystem/onlineStudyDetails",
        query: {
          trainingId: course.id,
        },
      });
      let routerList = [];

      let routers = [
        "/personalCenter",
        "trainingSystemMy",
        "/personalCenter/trainingSystem/onlineStudyDetails",
      ];
      for (let i = 0; i < routers.length; i++) {
        let routerData = findRoute(this.$router.options.routes, routers[i]);
        routerList.push(routerData);
      }
      this.changeRouterList(routerList);
    },
    handleSizeChange(index) {},
    handleCurrentChange(index) {
      this.currentPage = index;
      this.getList();
    },
    // 关闭弹窗时可选重置状态
    handleClose() {
      this.closeDialog(); // 关闭弹窗并清空数据
    },
    // 查看详情（打开弹窗）
    checkDetails(course) {
      // 将课程列表存入 Vuex 并显示弹窗
      const courses = course.courseList.map((v) => ({
        signUpTime: v.signUpTime,
        isExpire: v.isExpire,
        trainingStudyProgress: v.trainingStudyProgress,
        ...v.training,
      }));
      this.showDialog(courses);
    },
    // 弹窗：每页条数变化
    handleDialogSizeChange(val) {
      this.SET_DIALOG_PAGE_SIZE(val);
      this.SET_DIALOG_CURRENT_PAGE(1); // 重置为第一页
    },
    // 弹窗：当前页变化
    handleDialogCurrentChange(val) {
      this.SET_DIALOG_CURRENT_PAGE(val);
    },
  },
};
</script>

<style lang="less" scoped>
.my-courses {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .price {
      color: #ff6b00;
      font-weight: bold;
    }

    .card-body {
      margin-top: 16px;
      .action-button {
        background: #ed9d26;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        border: none;
        padding: 0 8px;
        line-height: 21px;
      }
      .disabled-button {
        background: #c0c4cc;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        border: none;
        padding: 0 6px;
        line-height: 21px;
      }
    }
  }
}
.pages {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}

::v-deep .el-pager li.active {
  color: #ed9d26;
}

.button {
  height: 24px;
  line-height: 24px;
  background: #ed9d26;
  border-radius: 4px;
  padding: 0 8px;
  border: none;
  margin-right: 8px;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-dialog__body {
  // padding: 0;
}
::v-deep .el-dialog__header {
}
</style>
